export const PROJECTS = [
  {
    slug: "sara-palmer-dds",
    name: "Sara Palmer DDS",
    industry: "Dental / Healthcare",
    services: "Custom Website + Local SEO",
    traffic: "+248%",
    leads: "+312%",
    img: "https://portfolio.echowingsmedia.com/wp-content/uploads/2026/03/desktop-4.png",
    href: "https://www.sarahpalmerdds.com/",
    location: "Grandville, MI",
    duration: "8 weeks",
    summary:
      "Sara Palmer DDS is a premium family dental practice in Grandville, Michigan. They came to us with an outdated website that wasn't ranking and barely converted visitors into appointments. We rebuilt the entire digital presence.",
  },
  {
    slug: "lakeshore-express",
    name: "Lakeshore Express",
    industry: "Logistics / Transport",
    services: "Website + Brand System",
    traffic: "+196%",
    leads: "+184%",
    img: "https://portfolio.echowingsmedia.com/wp-content/uploads/2026/03/desktop-2.png",
    href: "https://lakeshore.express/",
    location: "Grand Rapids, MI",
    duration: "6 weeks",
    summary:
      "Premium airport-shuttle service for the Lakeshore region. Needed a modern, trust-signaling site that converts directly to bookings.",
  },
  {
    slug: "jason-paige",
    name: "Jason Paige",
    industry: "Music / Personal Brand",
    services: "Premium Portfolio + GEO",
    traffic: "+285%",
    leads: "+220%",
    img: "https://portfolio.echowingsmedia.com/wp-content/uploads/2026/03/desktop-1.png",
    href: "https://jasonpaige.com/",
    location: "New York, NY",
    duration: "5 weeks",
    summary:
      "Recording artist and Voice of a Generation. Required a cinematic personal-brand portfolio with strong AI-visibility for media bookings.",
  },
  {
    slug: "myroofnexus",
    name: "MyRoofNexus",
    industry: "Roofing",
    services: "Website + Local SEO + GEO",
    traffic: "+340%",
    leads: "+412%",
    img: "https://portfolio.echowingsmedia.com/wp-content/uploads/2025/09/desktop-1-1.png",
    href: "https://myroofnexus.com/",
    location: "Michigan",
    duration: "7 weeks",
    summary:
      "#1 Michigan roofing & exterior experts. Needed lead-engine site + market-dominating local SEO.",
  },
  {
    slug: "buildwithkoda",
    name: "Build With Koda",
    industry: "Construction / Home Building",
    services: "Custom Build + Conversion",
    traffic: "+218%",
    leads: "+267%",
    img: "https://portfolio.echowingsmedia.com/wp-content/uploads/2025/09/desktop-1.png",
    href: "https://buildwithkoda.com/",
    location: "Michigan",
    duration: "6 weeks",
    summary:
      "High-end roofing, remodeling and home improvement company. Required a brand-elevating site that signals premium quality.",
  },
];

export const getProjectBySlug = (slug) =>
  PROJECTS.find((p) => p.slug === slug);
